import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, MessageSquare, Star, MessageCircle, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { timeAgo } from "@/lib/categories";
import { useAuth } from "@/context/AuthContext";

const ICONS = { message: MessageSquare, review: Star, comment: MessageCircle };

export default function NotificationsPage() {
  const nav = useNavigate();
  const { user, setAuthOpen, refreshBadges } = useAuth();
  const [items, setItems] = useState([]);

  useEffect(() => { if (user === false) setAuthOpen(true); }, [user, setAuthOpen]);
  useEffect(() => {
    if (user && user !== false) {
      api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});
      api.post("/notifications/read").then(() => refreshBadges && refreshBadges()).catch(() => {});
    }
  }, [user]);

  const del = async (id) => {
    try { await api.delete(`/notifications/${id}`); setItems((xs) => xs.filter((x) => x.id !== id)); toast.success("U fshi"); } catch { toast.error("Nuk u fshi"); }
  };
  const delAll = async () => {
    if (!window.confirm("Të fshihen të gjitha njoftimet?")) return;
    try { await api.delete("/notifications"); setItems([]); toast.success("U fshinë"); } catch { toast.error("Nuk u fshinë"); }
  };

  if (!user || user === false) return <div className="p-8 text-center text-slate-500">Kyçu për njoftimet.</div>;

  return (
    <div className="gs-fade px-4 pt-4">
      <div className="flex items-center justify-between mb-3">
        <h1 className="flex items-center gap-2 text-2xl font-extrabold text-slate-900"><Bell className="w-6 h-6 text-emerald-500" />Njoftimet</h1>
        {!!items.length && <button data-testid="notifications-delete-all" onClick={delAll} className="flex items-center gap-1 text-xs font-semibold text-rose-600 bg-rose-50 px-3 py-1.5 rounded-full"><Trash2 className="w-3.5 h-3.5" />Fshij të gjitha</button>}
      </div>
      <div className="space-y-2">
        {items.map((n) => {
          const Icon = ICONS[n.type] || Bell;
          return (
            <div key={n.id} className={`flex items-center gap-2 rounded-2xl border pr-2 ${n.read ? "bg-white border-slate-100" : "bg-emerald-50 border-emerald-100"}`}>
              <button data-testid={`notification-${n.id}`} onClick={() => n.link && nav(n.link)} className="flex-1 flex items-center gap-3 p-3.5 text-left">
                <div className="w-9 h-9 shrink-0 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center"><Icon className="w-4 h-4" /></div>
                <div className="flex-1"><div className="text-sm text-slate-700">{n.text}</div><div className="text-xs text-slate-400">{timeAgo(n.created_at)}</div></div>
              </button>
              <button data-testid={`notification-delete-${n.id}`} onClick={() => del(n.id)} aria-label="Fshij" className="w-9 h-9 shrink-0 rounded-full text-slate-400 hover:text-rose-600 hover:bg-rose-50 flex items-center justify-center"><Trash2 className="w-4 h-4" /></button>
            </div>
          );
        })}
        {!items.length && <p className="text-center text-slate-400 py-10">Ende pa njoftime.</p>}
      </div>
    </div>
  );
}
